import { useState } from "react";
import { Lock, ArrowRight } from "lucide-react";
import { cn } from "@/dentlab/src/lib/utils/cn";
import { useCentralStore } from "@/dentlab/src/store/Central";
import { SetPasswordDialog } from "@/components/src/set-password-dialog/set-password-dialog";

interface PasswordBannerProps {
	expanded: boolean;
}

export const PasswordBanner: React.FC<PasswordBannerProps> = ({ expanded }) => {
	const needsPasswordSetup = useCentralStore(
		(state) => state.needsPasswordSetup
	);
	const setNeedsPasswordSetup = useCentralStore(
		(state) => state.setNeedsPasswordSetup
	);
	const [dialogOpen, setDialogOpen] = useState(false);

	if (needsPasswordSetup !== true) return null;

	const handleSuccess = () => {
		setNeedsPasswordSetup(false);
	};

	return (
		<>
			<div
				className={cn(
					"flex items-center gap-2 py-2 pl-2 pr-3 rounded-md border cursor-pointer transition-colors",
					"bg-amber-50 border-amber-200 hover:bg-amber-100"
				)}
				onClick={() => setDialogOpen(true)}
				title="Passwort setzen"
				aria-label="password-banner"
				data-testid="password-banner"
			>
				<div className="w-6 h-6 flex items-center justify-center">
					<Lock className="h-4 w-4 text-amber-600" />
				</div>
				{expanded && (
					<div className="flex items-center gap-2">
						<div className="flex-1">
							<div className="text-xs font-medium text-amber-900">
								Passwort erforderlich
							</div>
							<div className="text-xs flex items-center gap-1 text-amber-700">
								Jetzt setzen
								<ArrowRight className="h-3 w-3" />
							</div>
						</div>
					</div>
				)}
			</div>
			<SetPasswordDialog
				open={dialogOpen}
				onClose={() => setDialogOpen(false)}
				onSuccess={handleSuccess}
			/>
		</>
	);
};
